export default "__VITE_ASSET__9rU3stDk__"